<app-application-form>
    <app-applicant slideNumber="1"></app-applicant>
    <app-joint-applicant slideNumber="1a"></app-joint-applicant>
    <app-residents slideNumber="2"></app-residents>
    <app-affordability slideNumber="3"></app-affordability>
    <app-safeguarding slideNumber="4"></app-safeguarding>
    <app-references slideNumber="5"></app-references>
    <app-joint-applicant-references slideNumber="5a"></app-joint-applicant-references>
    <app-terms-and-conditions [termsAndConditionsPageHeading]="termsAndConditionsPageHeading"
        [termsAndConditionsBodyText]="termsAndConditionsBodyText" slideNumber="6" [finalSlide]="true">
    </app-terms-and-conditions>
</app-application-form>

<style>
    :host ::ng-deep .applicationSubmitSpinner::ng-deep {
        position: absolute;
        left: 86px;
        bottom: 6px;
    }
</style>